import React from 'react';
import { isMobileOnly } from 'react-device-detect';

import SocialLinks from '../generalComponents/SocialLinks';
import footerLogo from '../../assets/nn-footer-logo-0065d828c6f63f8d94592011daa005e7.png';
import nakedNewsLiveLogo from '../../assets/NakedNewsLive/NNL_footer.png';
import { UserContext } from '../../context';
import { isNakedNewsLiveDomain } from '../../utils/helpers';


const today = new Date();
const currentYear = today.getFullYear();

const copyright = `
    Copyright, 1999-${currentYear} Naked Broadcasting Network Inc. All Rights Reserved.
    "Naked News" is a registered trademark of Egalaxy Multimedia Inc.
`;

const NakedNewsFooter = () => {
  const user = React.useContext(UserContext);
  const isAnchor = user.user && !!user.user.account.anchor;
  const shouldHideAffiliatesLink = window.location.pathname === '/affiliates';
  const logoToUse = isNakedNewsLiveDomain ? nakedNewsLiveLogo : footerLogo;

  return (
    <div className="footer">
      <div className="container">
        <div className="row-r footer-container">
          <div className="col-xs-12 text-center">
            <img
              alt="Nn footer logo"
              className={`img-responsive ${!isMobileOnly ? '' : 'logo'}`}
              src={logoToUse}
            />
          </div>
          {!isMobileOnly && isAnchor ? null : (
            <>
              <div className="col-xs-12 text-center">
                <SocialLinks />
              </div>
              <div className="col-xs-12 text-center">
                <ul className="list-unstyled">
                  {!isAnchor && (<li className=" ">
                    <a href="/account/purchase">
                      Join Naked News
                    </a>
                  </li>)}
                  <li className=" ">
                    <a href="/home">Today&#39;s Show</a>
                  </li>
                  <li className=" ">
                    <a href="/naked-amateur-auditions">
                      Amateur Auditions
                    </a>
                  </li>
                  <li className=" ">
                    <a href="/archives">Archives</a>
                  </li>
                  <li className=" ">
                    <a href="/media">Media</a>
                  </li>
                </ul>
              </div>
              <div className="col-xs-12 text-center">
                <ul className="list-unstyled">
                  <li className=" ">
                    <a href="/contact">Contact Us</a>
                  </li>
                  {user.authenticated && (
                    <li className=" ">
                      <a href="/account">My Account</a>
                    </li>
                  )}
                  {(user.authenticated && !isAnchor) && (
                    <li className=" ">
                      <a href="/account/subscriptions">
                        Cancel Subscription
                      </a>
                    </li>
                  )}
                  <li className=" ">
                    <a href="/faq">F.A.Q.</a>
                  </li>
                  <li className=" ">
                    <a href="/privacy_policy">Privacy Policy</a>
                  </li>
                  <li className=" ">
                    <a href="/cookie-policy">Cookie Policy</a>
                  </li>
                  <li className=" ">
                    <a href="/cookie-settings">
                      Cookie Settings
                    </a>
                  </li>
                  <li className=" ">
                    <a href="/terms_of_service">
                      Terms and Conditions
                    </a>
                  </li>
                  {!shouldHideAffiliatesLink && <li className=" ">
                    <a href="/affiliates" rel="noopener noreferrer" target="_blank">
                      Affiliates
                    </a>
                  </li>}
                  <li className=" ">
                    <a href="/2257">18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement</a>
                  </li>
                  <li className=" ">
                    <a href="/billing/processing">
                      Billing Support
                    </a>
                  </li>
                  <li className=" ">
                    <a
                      href="https://www.mrskin.com/tour?_atc=888591-2-1"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Mr. Skin
                    </a>
                  </li>
                </ul>
              </div>
            </>
          )}
        </div>
        <p className="copy">{copyright}</p>
      </div>
    </div>
  );
};

export default NakedNewsFooter;
